var Story = {};
var scrollBody = document.querySelector('.js-scroll-progress-body');
var scrollPercentage = document.querySelectorAll('.js-scroll-progress');
var header = document.querySelector('.js-header');
Story.init = function () {
  $(window).on('load', function () {
    Story.progressBar();
  });
};
Story.progressBar = function () {
  if (!scrollBody) return;
  if (scrollBody.children.length > 0) {
    document.addEventListener('scroll', function () {
      var docElem = document.documentElement;
      var docBody = document.body;
      var scrollTop = (docBody.scrollTop || docElem.scrollTop) + header.offsetHeight;
      var scrollBodyHeight = scrollBody.offsetHeight + header.offsetHeight;
      var scrolled = (scrollTop - scrollBody.offsetTop) / (scrollBodyHeight - scrollBody.offsetTop) * 100;
      for (var i = 0; i < scrollPercentage.length; i++) {
        scrollPercentage[i].style.setProperty('width', scrolled + '%');
      }
      if (scrollBody.offsetTop <= scrollTop) {
        header.classList.add('is-progressBar');
      } else {
        header.classList.remove('is-progressBar');
      }
    });
  }
};
Story.init();


// WEBPACK FOOTER //
// ./scripts/components/interstellar/story.js